import { Navigate, useOutletContext } from "react-router";
import { Context } from "../App";
import { href } from "../util";

const pwa = window.matchMedia("(display-mode: standalone)").matches;
const ios = navigator.userAgent.match(/(iPad|iPhone|iPod)/g);

export const Home = () => {
	const { accounts, initialSelectedAccount } = useOutletContext<Context>();

	if (!pwa && ios) {
		return (
			<section id="ios">
				<p>This app works best if you install it to your homescreen:</p>
				<img
					src="/safari_toolbar.webp"
					alt="Select share from Safari toolbar"
				/>
				<img
					src="/safari_menu.webp"
					alt="Select add to Home Screen from Safari menu"
				/>
				<img src="/safari_add.webp" alt="Select add button in top right" />
			</section>
		);
	} else if (Object.keys(accounts).length < 1) {
		return <Navigate to="/login" />;
	} else {
		const accountId =
			initialSelectedAccount &&
			Object.keys(accounts).includes(initialSelectedAccount || "")
				? initialSelectedAccount
				: Object.keys(accounts)[0];
		return <Navigate to={href("/accounts/:accountId", { accountId })} />;
	}
};
